'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _helpers = require('redux/saga/helpers');

var _path = require('helpers/path');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = exports.Link = function (_PureComponent) {
  (0, _inherits3.default)(Link, _PureComponent);

  function Link() {
    var _ref;

    (0, _classCallCheck3.default)(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Link.__proto__ || (0, _getPrototypeOf2.default)(Link)).call.apply(_ref, [this].concat(args)));

    _this.handleExternalClick = _this.handleExternalClick.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Link, [{
    key: 'handleExternalClick',
    value: function handleExternalClick(event) {
      var to = this.props.to;


      this.handleClick();

      if (!(0, _path.isExternalDomain)(to)) {
        event.preventDefault();
        (0, _helpers.gtmSafeRedirect)(to);
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var onClick = this.props.onClick;


      if (onClick) {
        onClick.apply(undefined, arguments);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          forceReload = _props.forceReload,
          to = _props.to;


      return forceReload || (0, _path.isExternal)(to) ? _react2.default.createElement(
        'a',
        (0, _extends3.default)({
          className: className,
          href: to,
          onClick: this.handleExternalClick
        }, (0, _path.isExternalDomain)(to) && {
          target: '_blank',
          rel: 'noopener noreferrer'
        }),
        children
      ) : _react2.default.createElement(
        _reactRouter.Link,
        {
          className: className,
          to: to,
          onClick: this.handleClick
        },
        children
      );
    }
  }]);
  return Link;
}(_react.PureComponent);

Link.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  forceReload: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  to: _propTypes2.default.string.isRequired
};